<script>
import EditableNumber from '@components/editables/editable-number.vue';
import { modalMethods, modalComputed, workoutMethods, workoutComputed, orgComputed, orgMethods } from '@state/helpers';
import _ from 'lodash';

export default {
  components: {
    EditableNumber,
  },
  props: {},
  data() {
    return {
      updatedNum: null,
    };
  },
  computed: {
    ...workoutComputed,
    ...modalComputed,
    ...orgComputed,
    colors() {
      return {
        '--color':  this.primaryColor
      }
    },
    type() {
      return this.confirmationModalCtx && this.confirmationModalCtx.type;
    },
    description() {
      if (this.type === 'reps') {
        return 'Change the number of reps you completed';
      }
      if (this.type === 'weight') {
        return 'Change the weight you completed';
      } else {
        return '';
      }
    },
    number() {
      return this.updatedNum
        ? this.updatedNum
        : this.confirmationModalCtx && this.confirmationModalCtx.data && this.confirmationModalCtx.data.value
        ? this.confirmationModalCtx.data.value
        : 0;
    },
  },
  mounted() {},
  methods: {
    ...workoutMethods,
    ...modalMethods,
    ...orgMethods,
    async onUpdateSetDirections() {
      const clientSetDirectionsClone = _.cloneDeep(this.clientSetDirections);

      let flag = '';
      if (this.type === 'reps') {
        flag = 'clientReps';
      }
      if (this.type === 'weight') {
        flag = 'clientWeight';
      }

      clientSetDirectionsClone[this.confirmationModalCtx.data.currentSetIndex][flag] = this.updatedNum;
      await this.setClientSetDirections(clientSetDirectionsClone);
      this.updatedNum = null;
    },
    async handleSave() {
      switch (this.type) {
        case 'reps':
          await this.onUpdateSetDirections();
          this.close();
          break;
        case 'weight':
          await this.onUpdateSetDirections();
          this.close();
          break;
        default:
          console.log(`No ${this.type} has been set`);
      }
    },
    async close() {
      await this.setConfirmationModalCtx(null);
      this.$bvModal.hide('confirmation-modal');
    },
  },
};
</script>

<template>
  <b-modal @hidden="close" id="confirmation-modal" centered :hide-footer="true" :hide-header="true" size="lg" no-stacking>
    <div @click="close" class="col close">&times;</div>
    <div v-if="confirmationModalCtx">
      <div class="title" :style="colors">Change {{ type }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <EditableNumber class="num" :number="number" @update-editable-num="updatedNum = $event" />
    <p @click="close" class="cancel">Close & Cancel</p>
    <BaseButton @click="handleSave" class="button btn-primary large">Change {{ type }}</BaseButton>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

::v-deep .modal-dialog {
  max-width: 450px !important;
  min-width: 20%;
  .modal-content {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 0 3px rgba(171, 171, 171, 0.5);
    .modal-body {
      align-items: center;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      min-height: 45vh;
      position: relative;
      .close {
        color: black;
        cursor: pointer;
        font-size: 4rem;
        opacity: 1;
        position: absolute;
        right: 5%;
        top: 5%;
        -webkit-transition-duration: 0.3s;
        width: fit-content;
        &:hover {
          color: darken(#000, 10);
        }
      }
      .title {
        color: var(--color);
        font-family: $base-font-family;
        font-size: 30.78px;
        font-style: normal;
        font-weight: bold;
        line-height: 37px;
        margin-bottom: 1.5rem;
        text-align: center;
        text-transform: capitalize;
      }
      .description {
        color: rgba(#000, 0.9);
        font-family: $proxima-nova;
        font-size: 16px;
        font-style: normal;
        font-weight: normal;
        line-height: 23px;
        text-align: center;
      }
      .num {
        color: black;
        font-family: $base-font-family;
        font-size: 64px;
        font-style: normal;
        font-weight: 800;
        line-height: 60px;
        margin-bottom: unset;
        text-transform: uppercase;
        @media screen and (min-width: 1100px) {
          @include calc-font-size(7.7);
        }
      }
      .cancel {
        color: rgba(#000, 0.5);
        cursor: pointer;
        font-family: $base-font-family;
        font-size: 17px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        text-align: center;
        text-transform: capitalize;
        -webkit-transition-duration: 0.3s;
        &:hover {
          color: black;
        }
      }
      .btn-primary {
        bottom: -30px;
        color: #fff;
        font-family: $roboto;
        font-size: 17px;
        font-style: normal;
        font-weight: 500;
        letter-spacing: 1px;
        position: absolute;
        text-align: center;
        text-transform: capitalize;
        width: 60%;
      }
    }
  }
}
</style>
